// GSAP Observer Fullpage Scroll for Cafe La Fin
// Add this script tag to your page BEFORE this code:
// <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js"></script>
// <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollToPlugin.min.js"></script>
// <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/Observer.min.js"></script>

$(document).ready(function () {
  $(document).on('click', '.collection-add-to-cart', function () {
  const productId = $(this).data('product-id');

  const $button = $(
    `quick-add-component product-form-component[data-product-id="${productId}"] add-to-cart-component button`
  );

  if ($button.length) {
    $button.trigger('click');
  } else {
    console.warn('Add to cart button not found for product:', productId);
  }
});


  // Handle "About Us" links on ALL pages first
  $('a[href*="#about-us"]').on('click', function (e) {
    e.preventDefault();
    
    // Close mobile menu first
    $('.menu-drawer__close-button').click();
    
    // Check if we're on the homepage
    const isHomepage = $('.one-page-scroll').length > 0;
    
    if (!isHomepage) {
      // We're on another page - redirect to homepage with hash
      window.location.href = '/#about-us';
      return;
    }
    
    // We're on homepage
    if ($(window).width() <= 1024) {
      // Mobile - scroll to the about section
      const $aboutSection = $('.shopify-section:has(.image-w-text-section)');
      if ($aboutSection.length) {
        setTimeout(() => {
          $('html, body').animate({
            scrollTop: $aboutSection.offset().top - 80
          }, 600);
        }, 300); // Wait for menu to close
      }
    } else {
      // Desktop - use fullpage scroll animation
      if (typeof gotoSection === 'function') {
        gotoSection(3, 1);
      }
    }
  });
  
  // CRITICAL: Only run fullpage scroll on pages with .one-page-scroll class
  if (!$('.one-page-scroll').length) {
    return; // Exit immediately if not on the one-page-scroll page
  }
  
  var $logo = $('.header-logo__image');
  var originalSrc = $logo.attr('src');
  var originalSrcset = $logo.attr('srcset');
  var inverseSrc = 'https://cdn.shopify.com/s/files/1/0973/3262/5489/files/Mask_group_3.png?v=1762515402';
  var inverseSrcset = inverseSrc + ' 1x, ' + inverseSrc + ' 2x, ' + inverseSrc + ' 3x';
  
  // Wait for GSAP to load
  if (typeof gsap === 'undefined') {
    console.error('GSAP not loaded! Add GSAP scripts to your page.');
    return;
  }

  // Register plugins
  gsap.registerPlugin(ScrollToPlugin);
  
  // Check if Observer is available
  if (typeof Observer === 'undefined') {
    console.error('Observer not loaded! Add Observer script to your page.');
    return;
  }
  
  gsap.registerPlugin(Observer);

  let sections = gsap.utils.toArray('.one-page-scroll main .shopify-section');
  let currentIndex = -1;
  let animating = false;

  // Make footer a section
  const $footer = $('footer');
  if ($footer.length) {
    $footer.addClass('shopify-section');
    $footer.appendTo('.one-page-scroll main');
    sections = gsap.utils.toArray('.one-page-scroll main .shopify-section');
  }

  // Set up sections - force white background where needed
  sections.forEach((section, i) => {
    const $section = $(section);
    
    // Get all background properties
    const bgColor = window.getComputedStyle(section).backgroundColor;
    const bgImage = window.getComputedStyle(section).backgroundImage;
    
    // Aggressively detect ANY white or light background
    let finalBgColor = bgColor;
    let hasLightBg = false;
    
    // Check section itself first
    const rgb = bgColor.match(/\d+/g);
    if (rgb && rgb.length >= 3) {
      const r = parseInt(rgb[0]);
      const g = parseInt(rgb[1]);
      const b = parseInt(rgb[2]);
      // Consider it white if RGB values are > 240
      if (r > 240 && g > 240 && b > 240) {
        hasLightBg = true;
      }
    }
    
    // If section is transparent, check ALL children
    if (bgColor === 'rgba(0, 0, 0, 0)' || bgColor === 'transparent' || !hasLightBg) {
      $section.find('*').each(function() {
        const childBg = window.getComputedStyle(this).backgroundColor;
        const childRgb = childBg.match(/\d+/g);
        
        if (childRgb && childRgb.length >= 3) {
          const r = parseInt(childRgb[0]);
          const g = parseInt(childRgb[1]);
          const b = parseInt(childRgb[2]);
          // Consider it white if RGB values are > 240
          if (r > 240 && g > 240 && b > 240) {
            hasLightBg = true;
            return false; // break loop
          }
        }
      });
    }
    
    // Force white background if detected OR if section contains specific content
    if (hasLightBg || $section.text().includes('ABOUT US') || $section.text().includes('Morning begins quietly')) {
      finalBgColor = '#ffffff';
    }
    
    // Apply styles to section with white background overlay if needed
    $section.css({
      'position': 'fixed',
      'top': '0',
      'left': '0',
      'width': '100%',
      'height': '100vh',
      'z-index': sections.length - i,
      'overflow': 'hidden',
      'background-color': finalBgColor,
      'background-image': finalBgColor === '#ffffff' ? 'none' : bgImage, // Remove bg image if white detected
      'background-size': 'cover',
      'background-position': 'center',
      '-webkit-transform': 'translate3d(0,0,0)',
      'transform': 'translate3d(0,0,0)',
      'will-change': 'transform'
    });
    
    // Make content scrollable if needed
    const $content = $section.children().first();
    if ($content.length) {
      $content.css({
        'height': '100%',
        'overflow-y': 'auto',
        'overflow-x': 'hidden'
      });
    }
    
    // Initially position all sections below viewport except first
    if (i > 0) {
      gsap.set(section, { yPercent: 100, visibility: 'hidden' });
    } else {
      gsap.set(section, { yPercent: 0, visibility: 'visible' });
    }
  });

  function gotoSection(index, direction) {
    // Prevent wrapping - stop at first and last section
    if (index < 0 || index >= sections.length) return;
    if (animating) return;
    
    animating = true;
    let previousIndex = currentIndex;

    // Update header styling with smooth transition
    if (index > 0) {
      if (!$('.header__row').hasClass('white-bg')) {
        $('.header__row').addClass('white-bg');
        // Use GSAP to smoothly transition the logo
        gsap.to($logo[0], {
          duration: 0.3,
          opacity: 0,
          onComplete: () => {
            $logo.attr('src', inverseSrc).attr('srcset', inverseSrcset);
            gsap.to($logo[0], { duration: 0.3, opacity: 1 });
          }
        });
      }
    } else {
      if ($('.header__row').hasClass('white-bg')) {
        $('.header__row').removeClass('white-bg');
        // Use GSAP to smoothly transition the logo
        gsap.to($logo[0], {
          duration: 0.3,
          opacity: 0,
          onComplete: () => {
            $logo.attr('src', originalSrc).attr('srcset', originalSrcset);
            gsap.to($logo[0], { duration: 0.3, opacity: 1 });
          }
        });
      }
    }

    let target = sections[index];
    let prev = previousIndex >= 0 ? sections[previousIndex] : null;
    
    // Set up target section
    gsap.set(target, { 
      zIndex: 100,
      visibility: 'visible'
    });
    
    // Determine slide direction
    let startY = direction > 0 ? 100 : -100;
    gsap.set(target, { yPercent: startY });
    
    // Slide animation
    gsap.to(target, {
      duration: 1,
      yPercent: 0,
      ease: "power3.out",
      force3D: true,
      onComplete: () => {
        // Clean up previous section
        if (prev) {
          gsap.set(prev, { 
            visibility: 'hidden',
            yPercent: -startY 
          });
        }
        
        // Reset z-index
        gsap.set(target, { zIndex: sections.length - index });
        
        animating = false;
        currentIndex = index;
      }
    });
  }

  // Smart scroll detection
  let scrollAccumulator = 0;
  let lastScrollTime = 0;
  let scrollResetTimer;
  let observerInstance;

  // Helper function to prevent scroll but allow pinch-to-zoom
  function preventScrollOnly(e) {
    // Only prevent if it's a single-touch scroll (not pinch-to-zoom)
    if (e.touches && e.touches.length === 1) {
      e.preventDefault();
    }
  }

  observerInstance = Observer.create({
    type: "wheel,touch",
    wheelSpeed: -1,
    onDown: (self) => {
      if (animating) return;
      
      const now = Date.now();
      const deltaY = Math.abs(self.deltaY);
      
      // If at first section, don't go further up
      if (currentIndex <= 0) return;
      
      // Mouse wheel: Large delta = instant trigger
      if (deltaY > 40) {
        if (now - lastScrollTime > 800) {
          lastScrollTime = now;
          scrollAccumulator = 0;
          gotoSection(currentIndex - 1, -1);
        }
        return;
      }
      
      // Trackpad: Small deltas = accumulate
      scrollAccumulator += deltaY;
      clearTimeout(scrollResetTimer);
      
      scrollResetTimer = setTimeout(() => {
        scrollAccumulator = 0;
      }, 150);
      
      // Trigger when accumulated enough scroll
      if (scrollAccumulator > 80) {
        scrollAccumulator = 0;
        gotoSection(currentIndex - 1, -1);
      }
    },
    onUp: (self) => {
      if (animating) return;
      
      const now = Date.now();
      const deltaY = Math.abs(self.deltaY);
      
      // If at last section, stop
      if (currentIndex >= sections.length - 1) return;
      
      // Mouse wheel: Large delta = instant trigger
      if (deltaY > 40) {
        if (now - lastScrollTime > 800) {
          lastScrollTime = now;
          scrollAccumulator = 0;
          gotoSection(currentIndex + 1, 1);
        }
        return;
      }
      
      // Trackpad: Small deltas = accumulate
      scrollAccumulator += deltaY;
      clearTimeout(scrollResetTimer);
      
      scrollResetTimer = setTimeout(() => {
        scrollAccumulator = 0;
      }, 150);
      
      // Trigger when accumulated enough scroll
      if (scrollAccumulator > 80) {
        scrollAccumulator = 0;
        gotoSection(currentIndex + 1, 1);
      }
    },
    tolerance: 10,
    preventDefault: false, // Changed to false to allow pinch-to-zoom
    onEnable: (self) => {
      // Manually prevent scroll but allow zoom
      document.addEventListener('touchmove', preventScrollOnly, { passive: false });
    },
    onDisable: (self) => {
      document.removeEventListener('touchmove', preventScrollOnly);
    }
  });

  // Handle hash navigation on homepage load
  function checkHashAndNavigate() {
    if (window.location.hash === '#about-us') {
      if ($(window).width() <= 1024) {
        // Mobile - scroll to section
        const $aboutSection = $('.shopify-section:has(.image-w-text-section)');
        if ($aboutSection.length) {
          setTimeout(() => {
            $('html, body').animate({
              scrollTop: $aboutSection.offset().top - 80
            }, 600);
          }, 500);
        }
      } else {
        // Desktop - use fullpage animation
        setTimeout(function(){
          if (typeof gotoSection === 'function') {
            gotoSection(3, 1);
          }
          $('.menu-drawer__close-button').click();
        }, 500); // Increased timeout to ensure sections are ready
      }
    }
  }
  
  // Run on initial load
  checkHashAndNavigate();
  
  // Also run after sections are initialized
  setTimeout(checkHashAndNavigate, 1000); // Increased timeout

  $('.discover-link').on('click', function(e){
  // Only prevent default and use scroll on desktop
  if ($(window).width() > 1024) {
    e.preventDefault();
    gotoSection(1, 1);
  }
  // On mobile, let the link work normally (it will go to the collection page)
});

  // Initialize on first section
  gotoSection(0, 1);
  
  // Add initialized class to prevent flash
  setTimeout(() => {
    $('body').addClass('initialized');
  }, 100);

  // Disable on mobile/tablet - restore normal scrolling
  if ($(window).width() <= 1024) {
    Observer.getAll().forEach(o => o.kill());
    
    // Remove fixed positioning and restore normal scroll
    sections.forEach((section) => {
      const $section = $(section);
      
      // Remove ALL inline styles that were added
      $section.removeAttr('style');
      
      // Add only necessary mobile styles
      $section.css({
        'position': 'static',
        'width': '100%',
        'height': 'auto',
        'min-height': '0',
        'overflow': 'visible',
        'transform': 'none',
        'visibility': 'visible',
        'z-index': 'auto',
        'background': '' // Let original background show
      });
      
      // Reset content scrolling
      const $content = $section.children().first();
      if ($content.length) {
        $content.removeAttr('style');
      }
    });
    
    // Reset header to original state
    $('.header__row').removeClass('white-bg');
    $logo.attr('src', originalSrc).attr('srcset', originalSrcset);
    
    // Enable smooth scrolling for anchor links
    $('html').css('scroll-behavior', 'smooth');
  }
});

